import { bankDetails, beneficiaries, regions } from './mocks';
import { BankDetails, BeneficiaryDetails, Region } from './reference-book-payment-details.types';

const BASE_URL = '';

export const getRegions = async (): Promise<Region[]> => {
    return regions;
};

export const getBeneficiaries = async (
    values: BeneficiaryDetails,
    page = 1,
    pageSize = 10
): Promise<BeneficiaryDetails[]> => {
    if (!values) return beneficiaries;
    return beneficiaries?.filter((b) =>
        Object.entries(values || {})?.every(([key, value]) =>
            b[key]?.toLowerCase().includes(value?.toLowerCase() ?? '')
        )
    );
};

export const getBankDetails = async (): Promise<BankDetails> => {
    return bankDetails;
};
